import * as style from './PanelDivider.module.less';

export const PanelDivider = () => {
    return <div className={style.panelRowDivier}></div>;
};
